import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

function passColor(rate) {
  return rate >= 90 ? '#00C2A8' : rate >= 70 ? '#F5A623' : '#E8415A';
}

export default function SourceMap({ sources, geo }) {
  const points = (sources || [])
    .filter(s => geo[s.ip]?.lat != null)
    .map(s => {
      const g = geo[s.ip];
      const rate = s.total > 0 ? Math.round((s.pass / s.total) * 100) : 0;
      return { ...s, lat: g.lat, lon: g.lon, country: g.country, city: g.city, isp: g.isp, as: g.as, rate };
    });

  if (!points.length) return null;

  return (
    <div style={{
      height: '360px',
      borderRadius: '12px',
      overflow: 'hidden',
      marginBottom: '20px',
      border: '1px solid rgba(0,194,168,0.15)',
    }}>
      <MapContainer
        center={[20, 0]}
        zoom={2}
        style={{ height: '100%', width: '100%' }}
        zoomControl
      >
        <TileLayer
          attribution='&copy; <a href="https://carto.com/attributions">CARTO</a> &copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
          subdomains="abcd"
          maxZoom={19}
        />
        {points.map(p => {
          const color = passColor(p.rate);
          const radius = Math.max(6, Math.min(22, Math.log2(p.total + 1) * 3.5));
          return (
            <CircleMarker
              key={p.ip}
              center={[p.lat, p.lon]}
              radius={radius}
              pathOptions={{ color, fillColor: color, fillOpacity: 0.65, weight: 1.5 }}
            >
              <Popup>
                <div style={{ fontFamily: 'monospace', fontSize: '12px', lineHeight: 1.6 }}>
                  <strong>{p.ip}</strong><br />
                  {p.city && `${p.city}, `}{p.country}<br />
                  {p.isp}<br />
                  {p.as}<br />
                  Pass rate: <strong style={{ color }}>{p.rate}%</strong>
                  &nbsp;({p.pass.toLocaleString()} / {p.total.toLocaleString()})
                </div>
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}
